import { InjectionToken } from '@angular/core';

/** A map coordinate pair, structurally compatible with `google.maps.LatLngLiteral`. */
export interface MapCoordinates {
  lat: number;
  lng: number;
}

/** Initial map center, applied before any site is selected (provided by the app from env config). */
export const MAP_DEFAULT_CENTER = new InjectionToken<MapCoordinates>(
  'google.maps.default.center',
);

/** Initial map zoom level, applied before any site is selected (provided by the app from env config). */
export const MAP_DEFAULT_ZOOM = new InjectionToken<number>(
  'google.maps.default.zoom',
);
